import { useRootStore } from 'contexts/RootStore.context';
import styled from 'styled-components';
import { colours } from 'styling/colours';
import { Device } from 'types/device';
import { assetEstimateIsNotFresh, getValueSafely } from 'utils/utils';

const StyledDiv = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  div:first-of-type {
    margin-right: 5px;
  }

  @media (max-width: 1800px) {
    flex-direction: column;
    div:first-of-type {
      margin-left: initial;
    }
  }
`;

const LocationCell = ({ value }: { value: Device }) => {
  let showError = false;
  const { freshPeriodThresholdSeconds } = useRootStore()

  if (assetEstimateIsNotFresh(value.last_update_timestamp, freshPeriodThresholdSeconds)) {
    showError = true;
  }
  if (value.location !== null) {
    return (
      <div
        className="u-no-pointer-event"
        data-tag="allowRowEvents"
        data-test={showError}
        style={{ color: showError ? `${colours.error}!important` : '' }}
      >
        <>
          <StyledDiv>
            <div data-test-id="floor-name" style={{ color: showError ? `${colours.error}` : '' }}>
              {getValueSafely(value.location?.building_level?.level.name)}/
              {getValueSafely(value.location?.building_level?.possible_buildings[0]?.name)}
            </div>
            <div
              data-test-id="region-name"
              style={{ color: showError ? `${colours.error}` : '' }}
            >
              {getValueSafely(value.location.region?.name)}
            </div>
          </StyledDiv>
        </>
      </div>
    );
  }

  return <>––</>;
};
export default LocationCell;
